// src/pages/components/TabelaMaquinas.jsx

import React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Box, CircularProgress, Grid, Icon } from '@mui/material';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useState } from 'react';
import DefaultImage from '../assets/Img/produto_default.png';


export default function CardsFotos({ produtos, onEdit, onDelete, loadingState }) {
    const { carregando, deletingId } = loadingState;
    const [imageError, setImageError] = useState(false);


    if (carregando === 'fetching' || carregando === 'searching') {
        return <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}><CircularProgress color="inherit" /></Box>
    }

    if (produtos.length === 0) {
        return <Box sx={{ textAlign: 'center', p: 5 }}>Nenhum produto encontrado.</Box>
    }

    //: `http://192.168.1.198:8851/Imgs/Produtos/${prod.caminho_img}`
    //: `/Imgs/Produtos/${prod.caminho_img}`
    // : `backendautoatendimentoapresentacao.inforservice.com.br/Imgs/Produtos/${prod.caminho_img}`

    return (
        <Grid container spacing={2} alignItems="center">
            {
                produtos.map((prod, index) => {
                    return (
                        <Grid item size={{ sx: 1, sm: 6, md: 4, lg: 4, xl: 1, xs: 12 }}>
                            <Card sx={{ width: '100%', height: '290px' }}>
                                <CardMedia
                                    component="img"
                                    image={imageError || !prod.caminho_img
                                        ? DefaultImage
                                        : `/Imgs/Produtos/${prod.caminho_img}`
                                    }

                                    onError={() => setImageError(true)}
                                    sx={{
                                        backgroundRepeat: 'no-repeat',
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        height: 180,
                                        width: '100%'
                                    }}
                                    title={prod.nome}
                                />

                                <CardContent>
                                    <Typography gutterBottom variant="h5" component="div">
                                        {prod.nome}
                                    </Typography>
                                </CardContent>
                                <CardActions sx={{ justifyContent: 'center' }}>
                                    <Button onClick={() => { onDelete(prod.cd_produto) }} size="large" variant='outlined'><DeleteIcon /></Button>
                                    <Button onClick={() => { onEdit(prod.cd_produto) }} size="large" variant='outlined'><ModeEditIcon /></Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    )
                })
            }
        </Grid>
    );
}